import React, {createRef, useEffect, useState} from 'react';
import './button.css'
import useIsMountedRef from "../../utils/mountedRef";


// example of component use: <ButtonYesno handleChange={handleChange} setter={setActeEnMain} onlyTrueFalse={true}/>

const ButtonYesno = (props) => {

    const [selectedValue, setSelectedValue] = useState(null);
    const isMountedRef = useIsMountedRef();
    const refYes = createRef();
    const refNo = createRef();
    const refUndefined = createRef();
    let [currentRef, setCurrentRef] = useState(null)

    function EventClick(refPassed, value, interactionType = null) {

        const selector = "button, input, select, textarea, a[href], [tabindex]";
        const previousFields = interactionType ? new Set(document.querySelectorAll(selector)) : null;
        const scrollPosition = interactionType ? {
            left: window.scrollX || window.pageXOffset,
            top: window.scrollY || window.pageYOffset,
        } : null;

        refPassed.current.classList.remove("item_no_selected");

        if (refPassed !== refYes) {
            refYes.current.classList.remove('item_selected')
            refYes.current.classList.add('item_no_selected')
        }

        if (refPassed !== refNo) {
            refNo.current.classList.remove('item_selected')
            refNo.current.classList.add('item_no_selected')
        }

        if (props.fieldUndefined && refPassed !== refUndefined) {
            refUndefined.current.classList.remove('item_selected')
            refUndefined.current.classList.add('item_no_selected')
        }

        refPassed.current.classList.add('item_selected');

        setCurrentRef(refPassed);
        setSelectedValue(value);      
        if (interactionType) {
            refPassed.current.focus({preventScroll: true});
        }

        props.handleChange(props.setter, value, props.reduxKey || null); // launch handleChange in parent simu

        if (interactionType) {
            window.requestAnimationFrame(() => {
                const firstNewField = Array.from(document.querySelectorAll(selector))
                    .find((field) => !previousFields.has(field));
                const focusTarget = interactionType === "keyboard" ? firstNewField : refPassed.current;

                focusTarget?.focus({preventScroll: true});
                window.scrollTo({...scrollPosition, behavior: "auto"});
            });
        }
    }
    
    const handleKeyDown = (e, currentIndex) => {
    const buttons = props.fieldUndefined
        ? [refYes, refNo, refUndefined]
        : [refYes, refNo];

        if (e.key === "ArrowRight") {
            e.preventDefault();
            if (currentIndex < buttons.length - 1) {
                const next = buttons[currentIndex + 1];
                EventClick(next, parseInt(next.current.dataset.value), "keyboard");
            }
        } 
        else if (e.key === "ArrowLeft") {
            e.preventDefault();
            if (currentIndex > 0) {
                const prev = buttons[currentIndex - 1];
                EventClick(prev, parseInt(prev.current.dataset.value), "keyboard");
            }
        }
    };

    useEffect(() => {
        switch (props.defaultValue) {
            case 2:
                EventClick(refUndefined, 2);
                break;
            case 1:
                EventClick(refYes, 1);
                break;
            case 0:
                EventClick(refNo, 0);
                break;
            default:
                break;
        }
    }, [isMountedRef, props.defaultValue]);

    return (
        <div className={"item_ctn"}>
            <button data-value="1" type="button" className={"common item_no_selected"} ref={refYes} 
            tabIndex={selectedValue === 1 ? 0 : -1}
            onClick={(event) => {
                if (typeof window.gtag === "function") {
                    window.gtag("event", "convention_honoraire_yes", {
                        event_category: "BoutonAction",
                        event_label: "convention_honoraire_yes",
                    });
                    }
                    EventClick(refYes, 1, event.detail === 0 ? "keyboard" : "mouse")
                }}
                onKeyDown={(e) => handleKeyDown(e, 0)}
            >
                Oui
            </button>

            <button data-value="0" type="button" className="common item_no_selected" ref={refNo} 
            tabIndex={selectedValue === 0 ? 0 : -1}
            onClick={(event) => {
                if (typeof window.gtag === "function") {
                    window.gtag("event", "convention_honoraire_no", {
                        event_category: "BoutonAction",
                        event_label: "convention_honoraire_no",
                    });
                    }
                    EventClick(refNo, 0, event.detail === 0 ? "keyboard" : "mouse")
                }}
                onKeyDown={(e) => handleKeyDown(e, 1)}
            >
                Non
            </button>

            {
                props.fieldUndefined ?
                    <button data-value="2" className={"common item_no_selected item_large"} ref={refUndefined}
                        tabIndex={selectedValue === 2 ? 0 : -1}  
                        onClick={(event) => {
                            EventClick(refUndefined, 2, event.detail === 0 ? "keyboard" : "mouse")
                        }}
                        onKeyDown={(e) => handleKeyDown(e, 2)}
                    >
                        Indéterminé
                    </button>
                    :
                    <></>
            }

        </div>
    );
};

export default ButtonYesno;
